<template>
    <div v-if="isSectionVisible" class="section-container">
            <component
            :is="sectionViewComponent"
            :index="index"
            :section="section"
            :rows="rows"
            :controls="controls"
            :key="section.uniqueId"
            :value-container="valueContainer"
                :visible-map="visibleMap"
            :validation-errors="validationErrors"
            :read-only="readOnly"
            :viewSubmissionMode="viewSubmissionMode"
            :siteID="siteID"
            :patNum=patNum
            :logoUrl="logoUrl"
            :formSubmissionIDForWeb="formSubmissionIDForWeb"
            :language="language"
        />
    </div>
</template>

<script>
    import {SECTION_TYPES} from "../../configs/section";

    export default {
        name: "SectionContainer",

        props: {
            index: Number,
            section: Object,
            rows: Object,
            controls: Object,
            visibleMap: Object,
            valueContainer: Object,
            validationErrors: Object,
            readOnly: Boolean,
            viewSubmissionMode: Boolean,
            siteID: String,
            patNum: Number,
            logoUrl: String,
            formSubmissionIDForWeb: String,
            language: {
                type: String,
                default: 'en'
            }
        },

        computed: {
            sectionViewComponent() {
                return SECTION_TYPES[this.section.type].rendererView
            },
            isSectionVisible() {
                // Use visibleMap[section.uniqueId] if present, else default to true
                if (this.visibleMap && this.section && this.section.uniqueId) {
                    if (typeof this.visibleMap[this.section.uniqueId] !== 'undefined') {
                        return !!this.visibleMap[this.section.uniqueId]
                    }
                }
                return true
            }
        },
    }
</script>

<style scoped>
</style>